var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFuel = function SvgFuel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fuel_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.825 10.412c.419 0 .8-.006 1.182 0 1.521.02 2.585 1.06 2.588 2.54.003 1.971.003 3.943 0 5.915 0 .43.142.784.493 1.049.74.556 1.82.156 1.99-.74.024-.13.033-.266.033-.399V8.607c-.098-.014-.181-.028-.265-.034-1.26-.08-2.233-1.064-2.248-2.292-.012-.925.006-1.848-.012-2.773a.652.652 0 0 0-.178-.415c-.488-.496-.996-.974-1.492-1.461-.433-.427-.46-.992-.068-1.37.39-.374.954-.354 1.387.064 1.45 1.395 2.893 2.796 4.34 4.194.288.28.422.611.422 1 0 4.448.006 8.899-.006 13.347-.006 1.787-1.39 3.139-3.158 3.13-1.648-.009-3.1-1.415-3.116-3.055-.02-1.963-.006-3.927-.006-5.887 0-.614-.208-.815-.85-.815h-1.024v9.743H0V2.669C0 1.07 1.058.052 2.712.052h8.451c1.593 0 2.662 1.032 2.662 2.577v7.783Zm-2.534-7.895H2.534v6.047h8.757V2.517Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fuel_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
};
export default SvgFuel;